import ReactDOM from "react-dom";

export const toElement = (element: JSX.Element): Element => {
  const el = document.createElement("div")

  ReactDOM.render(element, el)
  return el
}
